<template>
  <div class="mb-0 mr-1 badge-container">
    <b-badge
      v-if="status === 'pending'"
      pill
      variant="warning"
      badge-glow
    >
      {{ $t(`status.pending`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'processing'"
      pill
      badge-glow
      :style="{
        background: '#007bff',
        color: '#fff'
      }"
    >
      {{ $t(`status.processing`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'cancel'"
      pill
      variant="danger"
      badge-glow
    >
      {{ $t(`status.cancel`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'hold'"
      pill
      variant="primary"
      badge-glow
    >
      {{ $t(`status.hold`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'completed'"
      pill
      variant="success"
      badge-glow
    >
      {{ $t(`status.completed`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'resolved'"
      pill
      variant="secondary"
      badge-glow
    >
      {{ $t(`status.closed`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'unresolved'"
      pill
      variant="danger"
      badge-glow
    >
      {{ $t(`status.unresolved`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'handover'"
      pill
      variant="primary"
      badge-glow
    >
      {{ $t(`status.handover`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'accepted'"
      pill
      variant="success"
      :style="{
        background: '#2ecc71 !important',
        color: '#fff'
      }"
      badge-glow
    >
      {{ $t(`status.accepted`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'pendingPrice'"
      pill
      :style="{
        background: '#f1c40f',
        color: '#fff'
      }"
      variant="primary"
      badge-glow
    >
      {{ $t(`status.pendingPrice`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'pendingDispatch'"
      pill
      :style="{
        background: '#f39c12',
        color: '#fff'
      }"
      badge-glow
    >
      {{ $t(`status.pendingDispatch`) }}
    </b-badge>
    <b-badge
      v-else-if="status === 'rejected'"
      pill
      variant="danger"
      badge-glow
    >
      {{ $t(`status.rejected`) }}
    </b-badge>
    <b-badge
      v-else
      pill
      variant="secondary"
      badge-glow
    >
      {{ $t(`status.unknown`) }}
    </b-badge>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  components: { BBadge },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
  .pending {
    color: #ffc107;
  }

  .bg-pending {
    background-color: #ffc107;
  }

  .processing {
    color: rgb(0, 123, 255);
  }

  .bg-processing {
    background-color: rgb(0, 123, 255);
  }

  .cancel {
    color: #c0392b;
  }

  .bg-cancel {
    background-color: #c0392b;
  }

  .unresolved {
    color: #ff8c00; /* Dark Amber */
  }

  .bg-unresolved {
    background-color: #ff8c00; /* Matching background */
  }

  .hold {
    color: #8d5185;
  }

  .bg-hold {
    background-color: #8d5185;
  }

  .completed {
    color: #27ae60;
  }

  .resolved {
    color: #7e7e7e;
  }

  .bg-completed {
    background-color: #27ae60;
  }

  .bg-assign {
    background-color: #97b834;
  }

  .bg-resolved {
    background-color: #7e7e7e;
  }

  .bg-handover {
    background-color: var(--primary);
  }

  .handover {
    color: var(--primary);
  }

  .rejected {
    color: #e74c3c;
  }

  .bg-rejected {
    background-color: #e74c3c;
  }

  .bg-accepted {
    background-color: #2ecc71;
  }

  .bg-pendingPrice {
    background-color: #f1c40f;
  }

  .accepted {
    color: #2ecc71;
  }

  .pendingPrice {
    color: #f1c40f;
  }

  .badge-container {
    display: flex;
    align-items: center;

    .badge {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
